<abp-card class="zn-crud-page">
  <abp-card-body>
    <app-crud-page
      #crudPage
      [tableName]="config.localizationKey"
      [permission]="config.permission"
      [fields]="fields"
      [dataset]="dataset()"
      [loading]="loading()"
      [loadData]="loadData"
      [columnDefinitionsOverride]="columns"
      [extraTableOptions]="tableOptions"
      [hideCreateButton]="true"
      [disableEdit]="true"
      [disableEditInline]="true"
      [disableCanDelete]="true"
      [disableDuplicate]="true"
      (exportToExcelRecord)="exportToExcel()"
    >
      <ng-template #tableHeaderSubtitle>
        @if (queryExecuted()) {
          <div class="variations-summary">
            <p class="variations-summary-item">
              {{ 'Geographic::Entity.ForestryBase.Variations.ComparisonPeriodLabel' | abpLocalization }}:
              {{ comparisonPeriodText() }}
            </p>
            <div class="form-control-container">
              <div class="form-check-inner-container">
                <input class="form-check-input check-lg order-first"
                  id="executedIncludeNonPlantableAreas"
                  type="checkbox"
                  [checked]="executedIncludeNonPlantableAreas()"
                  disabled
                />
              </div>
              <label class="form-label form-check-label form-label-disabled" for="executedIncludeNonPlantableAreas">
                {{ 'Geographic::Entity.ForestryBase.Variations.IncludesNonPlantableAreas' | abpLocalization }}
              </label>
            </div>
          </div>
        }
      </ng-template>
    </app-crud-page>
  </abp-card-body>
</abp-card>

<abp-modal
  [visible]="showParametersModal()"
  [options]="modalOptions"
  (visibleChange)="onParametersModalVisibleChange($event)"
>
  <ng-template #abpHeader>
    <div class="modal-header-title">
      <h3>
        {{ 'Geographic::Entity.ForestryBase.Variations.ParametersTitle' | abpLocalization }}
      </h3>
      <h4>{{ config.localizationKey | abpLocalization }}</h4>
    </div>
  </ng-template>

  <ng-template #abpBody>
    <div class="zn-form variations-modal">
      <div class="row w-100">
        <div class="col-12">
          <div class="form-control-container">
            <label class="form-label" for="initialReportDate">
              {{ 'Geographic::Entity.ForestryBase.Variations.InitialReportDate' | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              id="initialReportDate"
              [options]="availableReportDates()"
              [placeholder]="'Geographic::Entity.ForestryBase.Variations.SelectReportDate'"
              [disabled]="loading() || loadingReportDates()"
              [ngModel]="initialReportDate()"
              (ngModelChange)="onInitialReportDateChange($event)"
            ></zn-single-select>
          </div>
        </div>

        <div class="col-12">
          <div class="form-control-container">
            <label class="form-label" for="finalReportDate">
              {{ 'Geographic::Entity.ForestryBase.Variations.FinalReportDate' | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              id="finalReportDate"
              [class.is-invalid]="hasInvalidDateRange()"
              [options]="availableReportDates()"
              [placeholder]="'Geographic::Entity.ForestryBase.Variations.SelectReportDate'"
              [disabled]="loading() || loadingReportDates()"
              [ngModel]="finalReportDate()"
              (ngModelChange)="onFinalReportDateChange($event)"
            ></zn-single-select>
            @if (validationMessage()) {
              <small class="invalid-feedback d-block">{{ validationMessage() }}</small>
            }
          </div>
        </div>

        <div class="col-12">
          <div class="form-control-container">
            <label class="form-label form-check-label p-0" for="includeNonPlantableAreas">
              {{ 'Geographic::Entity.ForestryBase.Variations.IncludeNonPlantableAreas' | abpLocalization }}
            </label>
            <div class="form-check-inner-container order-first p-0">
              <input
                id="includeNonPlantableAreas"
                class="form-check-input check-lg p-0"
                type="checkbox"
                [checked]="includeNonPlantableAreas()"
                [disabled]="loading()"
                (change)="onIncludeNonPlantableAreasChange($event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #abpFooter>
    <zn-button
      type="secondary"
      [label]="'LanguageService::Close' | abpLocalization"
      [disabled]="loading()"
      (clicked)="onParametersModalVisibleChange(false)"
    ></zn-button>

    <zn-button
      type="primary"
      loadingIconPosition="left"
      [label]="(queryExecuted()
        ? 'Geographic::Entity.ForestryBase.Variations.ReRunQuery'
        : 'Geographic::Entity.ForestryBase.Variations.RunQuery') | abpLocalization"
      [disabled]="!canExecuteQuery()"
      [loading]="loading()"
      (clicked)="runQuery()"
    ></zn-button>
  </ng-template>
</abp-modal>
